import DataSource from "../../data/datasource";

export default class MyUploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  upload() {
    return this.loader.file
      .then(file => new Promise((resolve, reject) => {
        return DataSource.shared.getEditorUploadURL(file).then((d) => {
          if (d.file0) {
            this.loader.uploaded = true;
            resolve({
              default: d.file0
            });
          } else {
            reject(`Couldn't upload file: ${file.name}.`);
          }
        });
      }));
  }

}